import styled from "@emotion/styled";

/** Generic browse page stack layout used by tickets and documents. */
export const StyledBrowsePage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
